import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType => {
	return {
		games: data.data,
		pagesTotal: data.pagination.total,
	};
};

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	page: data.page,
	per_page: data.perPage || 10,
});
